var map = {
	"./account.json": 41036,
	"./actions.json": 40204,
	"./auth.json": 86839,
	"./entities.json": 75942,
	"./footer.json": 80830,
	"./gallery.json": 62145,
	"./incidents.json": 73460,
	"./landing.json": 53588,
	"./leaderboard.json": 78252,
	"./login.json": 59854,
	"./popovers.json": 99691,
	"./reports.json": 40504,
	"./sponsors.json": 55426,
	"./submit.json": 89113,
	"./submitted.json": 31182,
	"./translation.json": 75372,
	"./validation.json": 95118,
	"./variants.json": 89887,
	"./wordcount.json": 31780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45194;